enum FoodSource {
    SHEEP = 'SHEEP',
    BERRY = 'BERRY',
    DEER = 'DEER',
    FARM = 'FARM',
    TWIN_MINARET_BERRY = 'TWIN_MINARET_BERRY',
    CATTLE = 'CATTLE',
    STOCKYARD = 'STOCKYARD'
}

export default FoodSource;
